/** SUMMARY
 * This is the styling for all tables used in the portal, we do not use this directly but it wraps the data grids/tables
 */
import { JSX } from "react";
import { DataGrid, DataGridProps } from "@mui/x-data-grid"
import { Box, } from "@mui/material"
import { makeStyles } from "@mui/styles";
// const StyledGridContainer = makeStyles(Box, {
//     shouldForwardProp: (prop) => prop !== 'disableBoxShadow',
// })<IStyledGridProps>(({ disableBoxShadow }) => ({
//     "& .results-grid": {
//         backgroundColor: "#F03F3F",
//         marginBottom: "24px",
//     },

//     // "& .results-grid--Severe": {
//     //   backgroundColor: "#FECACA",
//     //   "&:hover": { backgroundColor: "#FECACA" },
//     // },
//     "& .MuiDataGrid-columnsContainer": {
//         backgroundColor: "#3f51b5",
//         color: "#fff",
//     }, "& .MuiDataGrid-cell": {
//         display: "flex",
//         alignItems: "center",
//         minHeight: 52
//     },
//     "& .MuiDataGrid-root": {
//         background: "#fff",
//         border: "none",
//         boxShadow: disableBoxShadow
//             ? ""
//             : "0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)",
//     },
//     "& .MuiDataGrid-columnSeparator": {
//         display: "none!important",
//     },
//     "& .MuiDataGrid-sortIcon": {
//         color: "#fff",
//     },
//     "& .MuiDataGrid-menuIconButton": {
//         color: "#fff",
//     },
//     "& .MuiDataGrid-cell:focus-within, & .MuiDataGrid-cell:focus": {
//         outline: "none",
//     },
//     "& .MuiDataGrid-columnHeader:focus-within, & .MuiDataGrid-columnHeader:focus": {
//         outline: "none",
//     },
// }));
const useStyles = makeStyles({
    root: {
        "& .results-grid": {
            backgroundColor: "#F03F3F",
            marginBottom: "24px",
        },
        "& .MuiDataGrid-cell": {
            minHeight: 52
        },
        // '& .results-grid--Severe': {
        //     backgroundColor: "#FECACA",
        //     '& :hover': {
        //         backgroundColor: "#FECACA",
        //     }
        // },
        "& .MuiDataGrid-columnsContainer": {
            backgroundColor: "#3f51b5",
            color: "#fff",
        },
        "& .MuiDataGrid-root": {
            background: "#fff",
            border: "none",
            boxShadow: (props: any) =>
                (props as IStyledGridProps).disableBoxShadow
                    ? ""
                    : "0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)",
        },
        "& .MuiDataGrid-columnSeparator": {
            display: "none !important",
        },
        "& .MuiDataGrid-sortIcon": {
            color: "#fff",
        },
        "& .MuiDataGrid-menuIconButton": {
            color: "#fff",
        },
        "& .MuiDataGrid-cell:focus-within, & .MuiDataGrid-cell:focus": {
            outline: "none",
        },
        "& .MuiDataGrid-columnHeader:focus-within, & .MuiDataGrid-columnHeader:focus":
        {
            outline: "none",
        },
    },
});

interface IStyledGridProps {
    disableBoxShadow?: boolean;
    children?: React.ReactNode;
};
interface ITableStyledProps extends DataGridProps {
    disableBoxShadow?: boolean;
}
const TableStyled = (props: ITableStyledProps): JSX.Element => {
    const { disableBoxShadow, ...rest } = props;
    const classes = useStyles({ disableBoxShadow });

    return (
        <Box component="div" className={classes.root}>
            {/* // <StyledGridContainer disableBoxShadow={disableBoxShadow}> */}
            <DataGrid {...rest}
                sx={{
                    ".MuiDataGrid-columnHeader": {
                        backgroundColor: "#253D93",
                        color: "#fff",
                    },
                    "&. MuiDataGrid-columnSeparator": {
                        display: "none !important"
                    },
                    ".MuiDataGrid-columnHeaders": {
                        borderRadius: 0,
                    },
                    ".MuiDataGrid-root": {
                        boxShadow: "none",
                    },
                    ".MuiDataGrid-cell": {
                        alignContent: "center"
                    },
                    ".MuiDataGrid-row.Expired": {
                        backgroundColor: "lightgray",
                        color: "gray",
                        '&:hover': {
                            backgroundColor: 'lightgray',
                        },
                    },
                    "& .MuiDataGrid-columnHeaderTitle": {
                        whiteSpace: "normal",
                        lineHeight: "1.2",
                        overflow: "visible",
                        textOverflow: "unset"
                    },
                    ".MuiDataGrid-overlay": {
                        zIndex: 10
                    }
                }}
            />
            {/* </StyledGridContainer > */}

        </Box>
    )
}

export default TableStyled